import React, { useState, useRef, useMemo } from "react";
import ContentLayout from "../../../layouts/ContentLayout";
import { useOutletContext } from "react-router-dom";
import { SIDE_MENU } from "../constants";
import SelectTestSchedule from "../../../components/UI/Form/Select/SelectTestSchedule";
import Item from "./Item";
import { toast } from "react-toastify";
import Button from "app/components/UI/Button";
import PageLoadingBackdrop from "../../../components/CommonPage/PageLoadingBackdrop";

const BatchReportPage = () => {
  const itemRefs = useRef([]);
  const [breadcrumb] = useOutletContext();
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [availableData, setAvailableData] = useState([]);
  const [downloading, setDownloading] = useState(false);

  const cellStyle =
    "flex items-center justify-center p-2 bg-gray-200 border border-[#B3B3B3]";

  const itemDataArray = useMemo(() => {
    return selectedSchedule?.caseInfos
      .filter(
        (caseInfo) =>
          !caseInfo.report || caseInfo.reportStatus === "notStarted"
      );
  }, [selectedSchedule]);

  return (
    <ContentLayout
      sideMenuLinkOptions={SIDE_MENU}
      breadcrumb={breadcrumb}
    >
      <div className="w-full h-auto">
        <div className="w-full h-auto mb-5">
          <p className="text-custom-size mb-3">報告書一括送付</p>
        </div>
        <div className="w-1/2 h-auto flex items-center mb-3">
          <SelectTestSchedule
            isWhite
            schedule={selectedSchedule}
            setSchedule={setSelectedSchedule}
            filterFunc={(schedules) =>
              schedules
                .filter((schedule) => schedule.caseInfos.length > 0)
                .sort((a, b) => {
                  const date1 = new Date(a.testDate);
                  const date2 = new Date(b.testDate);
                  return date2 - date1;
                })
            }
          />
        </div>

        <div className="overflow-x-auto">
          <div
            className="grid grid-cols-11 p-4"
            style={{
              gridTemplateColumns:
                "110px 70px 120px 60px 70px 90px 100px 90px 60px 210px 55px",
            }}
          >
            <div className={"border-l " + cellStyle}>案件ID</div>
            <div className={cellStyle}>報告書</div>
            <div className={cellStyle}>企業名</div>
            <div className={cellStyle}>人数</div>
            <div className={cellStyle}>検体数</div>
            <div className={cellStyle}>判定医師*</div>
            <div className={cellStyle}>担当者名</div>
            <div className={cellStyle}>電話番号</div>
            <div className={cellStyle}>状況</div>
            <div className={cellStyle}>ファイルアップロード</div>
            <div className={cellStyle}>結果</div>
            {itemDataArray?.map((item, index) => (
              <Item
                key={item._id}
                ref={(el) => (itemRefs.current[index] = el)}
                data={item}
                fileDataArray={item.itemFileData}
                scheduleId={selectedSchedule?._id}
                setAvailableData={setAvailableData}
                setDownloading={setDownloading}
              />
            ))}
          </div>
        </div>

        <div className="flex items-end justify-end mt-4">
          <Button
            disabled={availableData.length === 0}
            type={availableData.length > 0 ? "primary" : "disabled"}
            onClick={() => {
              try {
                itemRefs.current.forEach((ref) => {
                  if (ref) ref.triggerClick();
                });
              } catch (error) {
                toast.error("送付に失敗しました");
                window.location.reload();
              }
            }}
          >
            報告書一括送付
          </Button>
        </div>
      </div>

      <PageLoadingBackdrop open={downloading} />
    </ContentLayout>
  );
};

export default BatchReportPage;
